import React from 'react';
import useOrders from '../../hooks/react-query/useOrder';
import useSidebarItems from '../../hooks/react-query/useSidebarItems';
// import usePersonStore from '../../store/personStore';

const Home = () => {
  const { data: sidebarData, isInitialLoading, isError } = useSidebarItems();
  const { data: orderData } = useOrders();

  return (
    <div class="row">
      {/* <div class="col-sm-6">
        <Card title={'Special title treatment'}>
          <p class="card-text">
            With supporting text below as a natural lead-in to additional
            content.
          </p>
          <a href="#" class="btn btn-primary">
            Go somewhere
          </a>
        </Card>
      </div>
      <div class="col-sm-6">
        <Card title={'Special title treatment'}>
          <p class="card-text">
            With supporting text below as a natural lead-in to additional
            content.
          </p>
          <a href="#" class="btn btn-primary">
            Go somewhere
          </a>
        </Card>
      </div> */}
    </div>
  );
};

export default Home;
